export default class ApiModalError implements Error {
  public name = 'ApiModalError';
  constructor(public message: string) {}
}
